import React, { useEffect, useState } from "react";
import Navigation from "../navigation/mainNavBar";

import "../footer/Policy.scss";

import Footer from "../footer/Footer";
import ArticleNavigation from "./Navigation";

const data = [
  { name: "WPROWADZENIE", id: "introduction", depth: 1 },
  { name: "PODSTAWY", id: "basics", depth: 1 },
  { name: "INTERAKCJE Z PRAWEM", id: "law_interactions", depth: 1 },
  {
    name: "POWOLNE BUDOWANIE NARRACJI",
    id: "action",
    depth: 1,
  },
  { name: "PORADY NA TEMAT POSTACI", id: "character-tutorial", depth: 1 },
  {
    name: "PORADY ODNOŚNIE TWORZENIA POSTACI",
    id: "character-create-tutorial",
    depth: 2,
  },
  { name: "CHARAKTER POSTACI", id: "character", depth: 2 },
  { name: "UMIEJĘTNOŚCI I MARZENIA POSTACI", id: "character-skills", depth: 2 },
  { name: "ZASADY DLA TWOJEJ POSTACI", id: "character-rule", depth: 2 },
  { name: "WYCHODŹ POZA RAMY!", id: "time", depth: 1 },
  {
    name: "PRZYKŁADY WYCHODZENIA POZA RAMY",
    id: "time-examples",
    depth: 2,
  },
  {
    name: "NIE BÓJ SIĘ ORGANIZOWAĆ EVENTÓW",
    id: "event",
    depth: 2,
  },
  { name: "TŁO HISTORYCZNE", id: "history", depth: 1 },
  { name: "REALIA DZIKIEGO ZACHODU", id: "wildwest", depth: 2 },
  { name: "TECHNOLOGIA", id: "technology", depth: 3 },
  { name: "SŁOWA", id: "words", depth: 3 },
  { name: "WAŻNE WYDARZENIA HISTORYCZNE", id: "important-history", depth: 3 },
  { name: "MODA", id: "fashion", depth: 1 },
  { name: "NOSZENIE MASKI", id: "mask", depth: 2 },
  { name: "DAMY/PANNY/PANIE", id: "ladies", depth: 2 },
  { name: "PANOWIE", id: "gentlemen", depth: 2 },
  { name: "PRZETRWANIE W DZICZY", id: "wild", depth: 2 },
  { name: "POGODA", id: "weather", depth: 3 },
  { name: "UBIÓR", id: "outfit", depth: 3 },
  { name: "ŻYCIE W DZICZY", id: "wild2", depth: 3 },
  { name: "ŚRODOWISKO", id: "environment", depth: 3 },
];

function Roleplay() {
  useEffect(() => {
    const sectionOffset =
      document.querySelector("section:first-of-type").offsetTop * 0.8;
    window.scrollTo({
      top: sectionOffset,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="Roleplay">
      <Navigation />
      <div className="content">
        <div className="title">WildLandsRP</div>
        <div className="sub-title">
          Przyjaciele, wrogowie i fortuna czekają na Ciebie!
        </div>
        <div className="main-butons-line"></div>
      </div>
      <div className="section-title">
        Poradnik roleplay dla nowych i stałych graczy oraz wprowadzenie w realia
        rozgrywki.
      </div>
      <section className="grid2">
        <div className="grid-item">
          <ArticleNavigation data={data}></ArticleNavigation>
        </div>
        <div className="grid-item">
          <strong>PAMIĘTAJ!</strong> To, co odgrywamy, jest historyczną fikcją,
          nie odtworzeniem lat 1900. Nie wszystko będzie wyglądało tak jak w
          tamtych czasach. Po prostu, należy podążać za zasadami.
          <h2 id="introduction">Wprowadzenie</h2>
          <p>
            Są to podstawy, potrzebne do funkcjonowania w społeczności, mające
            zagwarantować każdemu dobrą zabawę. Gdy tylko będziesz podążać za
            tymi zasadami, wszystko powinno być znacznie przyjemniejsze.
          </p>
          <h2 id="basics">Podstawy</h2>
          <ul>
            <li>Nigdy nie wychodź z postaci.</li>
            <li>
              Jeśli ktoś mówi o czymś OOC w IC, odgrywaj zdziwionego i postaraj
              się poprowadzić konwersację z powrotem do IC.
            </li>
            <li>
              Gdy ktoś stale wychodzi z postaci, postaraj się płynnie przerwać
              interakcję i zgłoś sytuację za pomocą ticketu.
            </li>
            <li>
              Traktuj regulamin, jako zasady OOC i nie wspominaj o nim IC, twoja
              postać nie zna regulaminu. Tylko Ty!
            </li>
            <li>
              Do zwracania uwagi na czyjeś problemy techniczne, używaj czatu
              L-OOC, nie używając metazwrotów, typu “musi Pan umyć uszy”, “chyba
              ma Pan chrypkę”.
            </li>
          </ul>
          <p>
            Nie zawsze musisz być głównym bohaterem, powinieneś dać z siebie
            wszystko, aby twoje RP, było przyjemne i ciekawe dla osób z którymi
            wchodzisz w interakcję.
          </p>
          <ul>
            <li>
              Bądź świadom tego, że inni też odgrywają Roleplay, oraz tego jak
              twoje działania mogą na nich wpłynąć.
            </li>
            <li>
              Czasami zajmujemy się tylko historią swojej postaci, czasem
              jesteśmy aktorem w historii innej. Postaraj się czerpać frajdę z
              obydwu typów rozgrywki, aby każdy mógł podążać swoją narracją.
            </li>
            <li>
              Nie mąć w wątkach innych, w które nie jesteś zaangażowany. Nie
              musisz być częścią każdej historii i wpływać na każdy wątek
              odgrywany na serwerze.
            </li>
          </ul>
          <p>
            Wygrywaj, albo przegrywaj do woli, tak długo jak nie łamiesz zasad,
            wszystko jest w porządku!
          </p>
          <ul>
            <li>
              Zazwyczaj, chcemy wygrać, bo bywa to znacznie zabawniejsze od
              przegranej, ale pamiętajmy, że samo to, że przegramy nie oznacza
              końca historii. Wręcz przeciwnie! Może to doprowadzić do wielu
              ciekawych sytuacji w przyszłości, w końcu ciekawej jest, jeśli coś
              stoi na drodze postaci.
            </li>
          </ul>
          <p>
            Postaraj się wchodzić na serwer z pewnym założeniem, tego co może
            zrobić twoja postać, bądź jednak otwarty na nowe sytuacje i
            wykorzystuj ciekawe okazje na roleplay. Pamiętaj, że nikt Cię nie
            goni, nie musisz się śpieszyć. Dodawaj do swojego roleplay’u
            pomniejsze szczegóły, które pomogą wczuć się Tobie jak i innym.
          </p>
          <ul>
            <li>
              Na przykład: zamiast przejeżdżać pełnym galopem przez miasto,
              wjedź spokojnie kłusikiem, albo poprowadź go za wodzę i przywiąż
              do pobliskiego słupka. Zamiast biec do banku, przejdź się
              spokojnie.
            </li>
            <li>
              Nie zapomnij o komendach narracyjnych! Nawet przy podawaniu, czy
              przy odstawianiu broni przy siodle.
            </li>
          </ul>
          <p>
            NPC to też człowiek i tak patrzy na niego twoja postać. Bezlitosne
            mordowanie i okradanie, jest raczej nie na miejscu. Pomyśl, czy to
            samo zrobiłbyś z graczem? Może jakiś NPC, potrzebuje pomocy, leży
            przy drodze nieprzytomny, zawieź go do lecznicy!
          </p>
          <h2 id="law_interactions">Interakcje z prawem</h2>
          <p>
            Stosuj się do popełnionych przez Ciebie przestępstw, np. jeśli jest
            to morderstwo, musisz zdawać sobie sprawę z tego, jak jest to
            ciężkie przestępstwo. Nie denerwuj się OOC, gdy ktoś Cię złapie.
            Przyjmuj kary i konsekwencje, jako element rozwoju twojej postaci.
          </p>
          <ul>
            <li>Szeryfowie, po prostu odgrywają swoją rolę.</li>
            <li>
              Nikt nie powinien niszczyć drugiej osobie RP, przez toksyczne
              zachowania przy zatrzymaniach lub karach.
            </li>
          </ul>
          <p>
            Poważne akcje przestępcze, powinny być traktowane poważnie i
            skrzętnie planowane.
          </p>
          <ul>
            <li>Np. nie napadaj na bank, tylko dlatego, że Ci się nudzi.</li>
          </ul>
          <p>
            Przeciętni mieszkaniec, nie był ekspertem od prawa konstytucyjnego,
            oraz szanował wymiar sprawiedliwości, jako że jest to organ, który
            gwarantuje mu bezpieczeństwo. Odgrywając przeciętnego mieszkańca, w
            twoim interesie jest jego dobro.
          </p>
          <p>
            Poważne przestępstwa lub seria takowych, mogą zakończyć się FCK od
            strony szeryfów, wszystko ma bowiem swoje konsekwencje, uważaj na
            swoje działania.
          </p>
          <h2 id="action">
            Powolne budowanie narracji, a bazowanie jej na akcji
          </h2>
          <p>
            Można skategoryzować roleplay na ten odgrywany powoli oraz ten, w
            którym zamieszani jesteśmy w akcję. Twoim celem jest balansowanie
            pomiędzy tymi dwoma typami.
          </p>
          <ul>
            <li id="building-action">Powolne budowanie narracji:</li>
            <ul>
              <li>
                Bądź świadom tego, że każde twoje działanie w RP, ma swoje
                konsekwencje, buduj powoli napięcie i staraj się doprowadzać je
                powoli do kulminacyjnego momentu.
              </li>
              <li>
                Np. Twoja postać to bandyta, który brał udział w kilku
                morderstwach i napadach. Została ona złapana przez szeryfów, a
                teraz postawiona jest przed sądem, może zostać skazana na karę
                śmierci. Cała historia rozwija się powoli, atmosfera narasta
                wraz z czasem, a następnie kończy się spektakularnym
                pochwyceniem.
              </li>
            </ul>
            <li id="action">Akcja:</li>
            <ul>
              <li>Akcjami są różne strzelaniny, napady na banki.</li>
              <li>
                Codzienne napady mogą być zabawne, ale skupianie się tylko i
                wyłącznie na tym aspekcie rozgrywki, który jest oparty na “Crime
                vs Sheriff”, doprowadzi do braku jakiejkolwiek historii, nie
                powinno to więc być podstawą postaci i roleplay’u.
              </li>
            </ul>
          </ul>
          <h2 id="character-tutorial">Porady na temat postaci</h2>
          <ul>
            <li>
              W roleplay'u skupiasz się właśnie na stworzeniu historii postaci,
              późniejszym odgrywaniu jej, oraz zagłębieniu się w nowe wątki, już
              na serwerze, oraz tworzeniu własnych, unikalnych historii.
            </li>
            <li>
              Gracz, powinien zastanowić się nad poczynaniami swojej postaci i
              pomyśleć, “Jak normalna osoba, z taką historią życiową,
              zachowałaby się w tej sytuacji”?
            </li>
          </ul>
          <h3 id="character-create-tutorial">
            Porady odnośnie tworzenia postaci
          </h3>
          <ul>
            <li>
              Znajdź jakieś fajne imię pasujące do czasów, które nie jest
              obraźliwe lub nazbyt humorystyczne
            </li>
            <li>
              Poszukaj inspiracji, wśród postaci historycznych, pozmieniaj coś w
              nich, albo nawet pomieszaj kilka historii życiowych w jedną. Może
              to doprowadzić do powstania unikalnej postaci
            </li>
            <li>
              Opracuj wstępną koncepcję postaci, pomyśl nad jej historią, zanim
              zacząłeś nią grać.
            </li>
          </ul>
          <h3 id="character">Charakter postaci:</h3>
          <ul>
            <li>
              Pomyśl nad pozytywnymi i negatywnymi cechami twojej postaci.
            </li>
            <li>
              Negatywne cechy urealniają naszą postać i nadają jej unikalnego
              charakteru.
            </li>
            <li>Przykład negatywnej cechy - nigdy nie skory do pomocy</li>
            <li>Przykład pozytywnej cechy - potrafi zachować spokój</li>
          </ul>
          <h3 id="character-skills">Umiejętności i marzenia postaci:</h3>
          <ul>
            <li>
              Znajdź umiejętności, których twoja postać jest pewna, oraz takie,
              przez które czuje niepewność lub strach.
            </li>
            <li>
              Znajdź coś o czym twoja postać marzy, ale też coś, czego twoja
              postać się obawia.
            </li>
          </ul>
          <h3 id="character-rule">Zasady dla twojej postaci:</h3>
          <ul>
            <li>Ustanów zasady dla twojej postaci i trzymaj się ich.</li>
            <li>
              Nakładanie ograniczeń na twoją postać i trzymanie się ich, może
              doprowadzić do naprawdę dynamicznego roleplay'u do którego by nie
              doszło, gdyby twoja postać, byłaby dobra we wszystkim i skora do
              każdego działania.
            </li>
            <li>
              Twoja postać nie ma mapy, więc nie korzystasz z niej jako gracz.
              Możesz się zgubić, wjechać na czyjś teren, albo napotkać coś
              ciekawego, co doprowadzi do nieplanowanej, dynamicznej akcji.
            </li>
            <li>
              Jako gracz, możesz znać całą mapę, jednak jeśli twoja postać,
              dopiero wprowadza się do hrabstwa, odegraj, że dopiero poznajesz
              okolicę.
            </li>
            <li>
              Ludzie specjalizowali się zazwyczaj w jednej kategorii. To nie
              jest zawsze korzystne, aby nasza postać byłaby we wszystkim
              najlepsza i opanowała wiele umiejętności, należy jednak pamiętać,
              że postać może się rozwijać wraz z upływem historii.
            </li>
            <li>
              Twoja postać powinna mieć zasady moralne. Kompas moralny postaci,
              pozwoli graczowi prowadzić swoją postać spójnie i prawidłowo.
            </li>
            <li>
              Rozpoczynanie rozgrywki z założeniem dla naszej postaci, pozwoli
              na ustalenie pomniejszych celów, oraz dalekosiężnych planów do
              wykonania.
            </li>
            <li>
              Wraz z nabieraniem doświadczenia, nie bój się próbować rozgrywki
              nowymi postaciami, które mogą zapewnić Ci inny wymiar rozgrywki.
            </li>
            <li>
              Znajdź cel dla swojej postaci. Jeśli twoja postać ma jakiś cel,
              ciekawe akcje same do Ciebie przyjdą po drodze do jego
              osiągnięcia.
            </li>
          </ul>
          <h2 id="time">Wychodź poza ramy!</h2>
          <p>
            Do odgrywania, nie zawsze potrzebne są mechaniki i skrypty. Użyj
            swojej wyobraźni, staraj się zająć czymś, co nie jest tylko podparte
            skryptem. Roleplay nie powinien opierać się tylko na “Szeryfowie vs
            Crime”. Wychodź poza ramy.
          </p>
          <h3 id="time-examples">
            Kilka przykładów, wychodzących poza ramy “crime vs sheriff”
          </h3>
          <ul>
            <li>Właściciel saloonu / barman</li>
            <li>Łowca nagród</li>
            <li>Lichwiarz / ściąganie długów</li>
            <li>Ochrona przewozów</li>
            <li>Transport</li>
            <li>Handlarz / licytator</li>
            <li>Myśliwy / Traper</li>
            <li>Lekarz</li>
            <li>Prawnik</li>
            <li>Krętacz / Szarlatan</li>
            <li>Plemienny Indianin</li>
            <li>Aktor / Scenarzysta</li>
            <li>Stajenny</li>
            <li>Rusznikarz</li>
            <li>Właściciel sklepu / sprzedawca</li>
            <li>Piekarz</li>
            <li>Rzemieślnik</li>
            <li>Stolarz</li>
            <li>Fotograf</li>
          </ul>
          <p>
            Ktoś oferuje jakąś usługę? Skorzystaj z niej, jest to okazja do
            urozmaicenia roleplay'u.
          </p>
          <h3 id="event">Nie bój się organizować eventów, takich jak:</h3>
          <ul>
            <li>Jarmarczne spotkanie</li>
            <li>Turniej w pokera</li>
            <li>Wyścigi konne</li>
            <li>Polowania na szkodniki</li>
          </ul>
          <h2 id="history">Tło historyczne, Realia Dzikiego Zachodu</h2>
          <ul>
            <li>
              <h3 id="wildwest">Ogólne spojrzenie na realia</h3>
              <p>Okres czasowy, który odgrywamy to 1890 - 1900</p>
              <p id="technology">Technologia</p>
              <ul>
                <li>
                  Silniki parowe, telegrafy, aparaty telefoniczne (zazwyczaj
                  jeden na miasto), rewolucja przemysłowa, tramwaje, pokaz
                  ruchomych obrazów, czarno-białe zdjęcia.
                </li>
              </ul>
              <p id="words">Słowa</p>
              <ul>
                <li>
                  Większość mieszkańców zachodu, operowało raczej prostym
                  językiem, w który często wplątane były słowa wyrastające z
                  innych kultur, z racji na powszechną emigrację do Ameryki.
                </li>
                <li>
                  Jeśli chodzi o wyzwiska, były one często oparte na nazwaniu
                  kogoś, najzwyczajniej w świecie głupkiem, przezwaniem go od
                  jakiegoś zwierzaka, lub zasugerowaniu, że ktoś korzysta z
                  usług kurtyzan, lub takowe oferuje.
                </li>
              </ul>
              <p id="important-history">Ważne wydarzenia historyczne</p>
              <ul>
                <li>30 lat po “Wojnie Domowej”</li>
                <li>Około 620.000 strat ludzkich po każdej ze stron.</li>
                <li>
                  Pamięć o “Wojnie Domowej”, bo tak powinniśmy nazywać ją z
                  amerykańskiej perspektywy, wciąż pozostaje żywa, wśród
                  starszego pokolenia.
                </li>
                <li>Południowcy, prześladowania po wojnie i zniszczenia,</li>
                <li>
                  Północ, może zarzucić bunt i korzystanie z pracy niewolników
                </li>
                <li>Homstead Act z roku 1862</li>
                <li>
                  Gwarantował on dostęp to taniej, lub nawet darmowej ziemi na
                  zachodzie
                </li>
                <li>Gorączka złota (1840-1900)</li>
                <li>
                  Wiele osób, ruszyło na zachód w poszukiwaniu łatwego i
                  szybkiego zarobku, jednak pod koniec XIX wieku, wiele kopalni
                  zostało już zajętych, oraz większość złota, została odkryta.
                </li>
                <li>Wojny Indiańskie</li>
                <li>
                  Pod koniec XIX wieku, płomienie wojen indiańskich dogasały.
                  Wciąż jednak istniały pomniejsze grupy stawiające opór, jednak
                  większość Indian zostało przesiedlonych do rezerwatów.
                  Asymilując się i w dużej części przechwytując europejski styl
                  ubioru.
                </li>
                <li>Wojna filipińsko-amerykańska</li>
                <li>
                  Trwająca od 1899 do 1902, w wyniku której Stany Zjednoczone
                  zyskały kontrolę nad Filipinami. Wojna miała wpływ na
                  społeczeństwo amerykańskie, krytykowano ją za brutalne metody
                  walki i zmuszanie mieszkańców Filipin do przyjęcia kultury i
                  języka amerykańskiego.
                </li>
                <li>Zanikanie pogranicza</li>
                <li>
                  Pogranicze, jako unikalna struktura społeczna, cechowała się
                  większą jej egalitarnością, poleganiem na swojej pracy i
                  możliwością rozwoju, kojarzonego z Ameryką (od zera do
                  millionera). Powoli jednak zanikało, włączane w struktury
                  amerykańskiego imperium.
                </li>
                <li>Różnice pomiędzy miejskimi, a wiejskimi gangami</li>
                <ul>
                  <li>Miejskie</li>
                  <ul>
                    <li>
                      Prawo egzekwowane przez miejskich Marshalli, policję
                    </li>
                    <li>
                      Wymuszanie haraczy, uzbrajanie swoich przedsiębiorstw
                    </li>
                  </ul>
                  <li>Wiejskie</li>
                  <ul>
                    <li>
                      Mniej stróżów prawa, poleganie na zwykłych mieszkańcach
                      (posse comitatus)
                    </li>
                    <li>Bandyctwo, przejmowanie własności, kradzieże bydła</li>
                  </ul>
                  <p>
                    Np. W mieście takim jak Saint Denis, "gangi", będą podobne
                    do współczesnych mafii, będą wymuszać haracze od bogatych
                    firm, gdy "gangi" wiejskie, na pograniczu, będą skupiały się
                    na kradzieżach oraz napadach.
                  </p>
                </ul>
                <li />
                <li>Maniery</li>
                <ul>
                  <li>Honorowe, a niehonorowe zachowanie</li>
                  <p>
                    Twoje słowa, to twoja reputacja. Mężczyzna musi być
                    człowiekiem słownym i zrobić to, co obiecał, lub odrzekł.
                    Postrzelenie kogoś w plecy, albo z zaskoczenia, jest tym, co
                    uznawano za skrajnie niehonorowe, jednak równy pojedynek, w
                    którym każdy ma szansę na dobycie broni, jest postrzegany
                    jako uczciwy.
                  </p>
                  <li>Stosunek do nieznajomych</li>
                  <p>
                    Od ludzi wymagało się gościnności oraz szacunku do
                    nieznajomych. Np. zaproszenie nieznajomego do domu lub do
                    ogniska.
                  </p>
                  <li>Stosunek mężczyzn do kobiet i vice versa</li>
                  <p>
                    Kobieta była traktowana z szacunkiem przez mężczyzn, każde
                    jakiekolwiek obraźliwe zachowanie w jej towarzystwie, mogło
                    zakończyć się nieprzyjemnościami ze strony innych panów.
                    Jednak kobiety zachowywały się wtedy nieco inaczej niż
                    obecnie, oczekiwano od nich wyzbycia się przekleństw,
                    podobnie jak od każdego, oraz nie patrzono przychylnie na
                    nadmierne spoufalanie się z mężczyznami.
                  </p>
                </ul>
              </ul>
            </li>
            <h2 id="fashion">Moda</h2>
            <h3 id="mask">Noszenie maski</h3>
            <p>
              Noszenie maski lub bandany było postrzegane jako nieprawidłowe i
              każdy, kto nosił maskę, uważany był za osobę niegodną zaufania.
              Ludzie osądzali innych zazwyczaj przez pryzmat ich ubioru, który w
              tamtych czasach był raczej kosztowny, więc to, jak się
              przebierałeś, mogło bezpośrednio wpłynąć na twoją reputację. Osoba
              przebrana jak bezdomny, była traktowana jak bezdomny, a osoba
              przebrana elegancko, była znacznie lepiej postrzegana.
            </p>
            <h3 id="ladies">Damy/Panny/Panie</h3>
            <p>
              Według obyczaju, kobieta powinna była zakryta niemal od stóp do
              głów. Nie powinna obnosić się aż nazbyt swoim dekoltem, czy też
              pokazywać swoje ramiona, odsłaniać kostek. Spodnie były noszone
              rzadko, jednak pamiętajmy, że jesteśmy w grze i widok kobiety w
              spodniach w nieformalnych okolicznościach, nie powinien być aż tak
              oburzający. Gdy były na zewnątrz, raczej nie nosiły odkrytej
              głowy. Dama nie powinna była zdejmować kapelusza, gdy wchodzi do
              budynku na krótki czas, jako oznaka szacunku.
            </p>
            <p>
              Jeśli chodzi o formalne okoliczności, kobieta nie musiała być aż
              tak zakryta. Ramiona oraz kawałek pleców, mógł być odsłonięty.
              Według zasad, kobiety powinny nosić spódnicę. Wskazany był wtedy
              brak kapelusza, często w rękawiczkach. Jeśli jednak, niewiasta
              zdecyduje się na spodnie, powinny być one czyste i dobrane
              odpowiednio do reszty stroju, jak zadbana koszula lub elegancka
              kamizelka.
            </p>
            <h3 id="gentlemen">Panowie</h3>
            <p>
              Według zasad, mężczyzna również nie powinien odkrywać zbyt wiele.
              Nikt nie będzie odsłaniał klatki piersiowej, lub ramion, chyba że
              zajęty jest ciężką pracą. W ciągu dnia powinien być przebrany
              stosownie do zajęcia, jakim się aktualnie pała.
            </p>
            <p>
              Męski formalny strój powinien składać się z czarnych, eleganckich
              spodni, koszuli (najlepiej białej), eleganckiej kamizelki oraz
              krawata, muchy lub apaszki. Noszenie kapelusza w urzędach i
              eleganckich przybytkach jest nieeleganckie i obraźliwe dla gości
              lub urzędu.
            </p>

            <h3 id="wild">Przetrwanie w dziczy i rzeczy z tym związane</h3>
            <ul>
              <li id="weather">Pogoda</li>
              <p>
                Nie lekceważ pogody i jej wpływu na twoją sytuację. Ludzie
                rzadko wychodzą na zewnątrz w czasie burzy lub ulewy. Poszukaj
                schronienia i upewnij się, że nie zmarzniesz i pozostaniesz
                bezpieczny.
              </p>
              <li id="outfit">Ubiór</li>
              <p>
                Przebieraj się zgodnie z tym, w jakich warunkach pogodowych
                będziesz przebywać. Po prostu przebierz się zanim pojedziesz do
                Ambarino i nie obrzucaj się skórami, gdy jedziesz do Armadillo.
                Udary i zamarznięcia to nieprzyjemne przeżycia, o ile można je
                nazwać przeżyciami.
              </p>
              <li id="wild2">Życie w dziczy</li>
              <p>
                W zależności od miejsca, w którym przebywasz, spotkasz
                różnorakie gatunki zwierząt, niektóre będą niebezpieczniejsze od
                innych. Przemyśl podróżowanie w pojedynkę, jeśli wybierasz się w
                tereny, znane z groźnych drapieżników, oraz lepiej trzymać się
                bliżej drogi. Zadbaj o prowiant, jeśli planujesz ruszyć w drogę,
                pracować lub po prostu zostać dłużej poza miastem. Czasami może
                być trudno z zapasami w dziczy oraz niezbędnymi przedmiotami,
                gdy w okolicy nie ma sklepu. Pomyśl o tym, jak zachowałaby się
                twoja postać w takiej sytuacji. Może jest leniem i nie zależy
                jej na przygotowaniach, a może jest doświadczonym myśliwym,
                który wie, że przygotowanie jest najważniejsze!
              </p>
              <li id="environment">Środowisko</li>
              <p>
                Postaraj się dowiedzieć czegoś na temat środowiska, w którym
                żyje twoja postać. Skup się głównie na jej miejscu zamieszkania,
                albo twoim ulubionym mieście, czy to będzie preria w okolicach
                Blackwater, albo może bagna niedaleko Saint Denis?
              </p>
            </ul>
          </ul>
        </div>
        <div className="grid-item"></div>
      </section>
      <Footer />
    </div>
  );
}

export default Roleplay;
